export const RESET_PASSWORD_FORM_NAME = 'reset-password-form';

export const RESET_PASSWORD_MODAL_STYLE = { width: '505px', height: '340px' };

export const REQUIRED_FIELDS = ['password', 'password_confirmation'];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
